(() => {
  window.jk = window.jk || {};
  window.jk.BootVariants = class BootVariants {
    product;
    $inStockCheckbox;

    constructor(productInfo) {
      window.BOLD &&
        BOLD.common.eventEmitter?.on(
          'BOLD_OPTIONS_option_products_loaded',
          function () {
            productInfo
              .querySelectorAll('div .bold_option.bold_option_checkbox > label .bold_option_title')
              .forEach((cb) => {
                if (cb.innerText.toLowerCase().includes('in stock')) {
                  this.$inStockCheckbox = cb.parentElement.querySelector('input[type=checkbox]');
                }
              });
          }.bind(this),
        );
      this.$availabilityMessage = productInfo.querySelector('.availability-message-block .availability-message');
      this.$inventoryStatusInput = productInfo.querySelector(`#InventoryStatus-${productInfo.dataset.productId}`);
      this.$manufacturingTimelineInput = productInfo.querySelector(
        `#ManufacturingTimeline-${productInfo.dataset.productId}`,
      );
      this.initProduct(productInfo);

      this.onOptionValueChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this),
      );
    }

    async initProduct(productInfo) {
      if (window.jk.warehouseTimeout) clearTimeout(window.jk.warehouseTimeout);

      const selectedVariant = productInfo.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
      const variant = !!selectedVariant ? JSON.parse(selectedVariant) : null;

      let attempts = 0;
      let inv = await this.getWarehouseInventory(productInfo.dataset.productId);
      while (inv.response && inv.response.status === 429 && attempts < 4) {
        attempts++;
        await new Promise((resolve) => {
          window.jk.warehouseTimeout = setTimeout(resolve, inv.data.tryAgainIn);
        });
        inv = await this.getWarehouseInventory(productInfo.dataset.productId);
      }
      const data = inv.data;

      if (!data || (!data.isStockProduct && !data.isNonStockProduct)) {
        //|| !variant
        this.unsubscribe();
        return;
      }

      const variantOptions = variant.options.slice(-2);
      this.product = {
        variants: data.variants,
        length: variantOptions[0],
        width: variantOptions[1],
      };

      this.dropNotifications = productInfo.dataset.dropNotifications === 'true';

      this.setState(productInfo.variantSelectors);
    }

    async getWarehouseInventory(productId) {
      try {
        //https://32h49ns6l8.execute-api.us-east-2.amazonaws.com/default/GetWarehouseInventory
        //9UR47e6q2AaC0W9KVXM5T8siDMsB1UhA4DS8rBMM
        //https://gfc7181cq4.execute-api.us-east-2.amazonaws.com/default/Dev-GetWarehouseInventory
        //hJa8CJyF9YaHvowSch3VE8rXhRifbhGx6BOWjKO0
        const response = await fetch(
          `https://32h49ns6l8.execute-api.us-east-2.amazonaws.com/default/GetWarehouseInventory?product-id=${productId}`,
          {
            method: 'GET',
            headers: { 'x-api-key': '9UR47e6q2AaC0W9KVXM5T8siDMsB1UhA4DS8rBMM' },
          },
        );
        const data = await response.json();
        return { response, data };
      } catch (error) {
        return { response: null, data: null, error };
      }
    }

    setState($variantSelects) {
      const widthOptions = [];
      $variantSelects.querySelectorAll('fieldset.size-width input').forEach((input) => {
        widthOptions.push(input.value);
        const key = this.product.length + ' / ' + input.value;
        const dataVariant = this.product.variants[key];
        // TODO => possible issue here where shopify number is 0 but warehouse number is greater than 0, so this is marked as disabled. Checking input fixes colors, but the availability message still has the wrong text.
        if (dataVariant && dataVariant.quantity > 0 && !input.classList.contains('disabled')) {
          input.classList.add('available');
        } else {
          input.classList.remove('available');
        }
      });
      $variantSelects.querySelectorAll('fieldset.size-length input').forEach((input) => {
        const available = widthOptions.some((opt) => {
          const key = `${input.value} / ${opt}`;
          const dataVariant = this.product.variants[key];
          return dataVariant && dataVariant.quantity > 0;
        });
        if (available) {
          input.classList.add('available');
        } else {
          input.classList.remove('available');
        }
      });
      this.updateMiscState(this.product.variants[`${this.product.length} / ${this.product.width}`]);
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      this.changeStatus = 'nochange';
      if (target.getAttribute('name').startsWith('Size Length')) {
        this.product.length = target.value;
        this.changeStatus = 'change';
      } else if (target.getAttribute('name').startsWith('Size Width')) {
        this.product.width = target.value;
        this.changeStatus = 'change';
      }
    }

    updateInputStatus($variantSelects) {
      if (this.changeStatus === 'change') {
        this.setState($variantSelects);
      }
    }

    updateMiscState(variant) {
      if (!variant) {
        this.$inventoryStatusInput.value = 'Nonexistent';
        this.setTimeline('Nonexistent', '_');
        this.$availabilityMessage?.parentElement?.classList.add('hide');
        this.$inStockCheckbox?.checked && this.setInStockCheckbox(false);
      } else if (variant.quantity > 0) {
        this.$inventoryStatusInput.value = 'In Stock';
        this.setTimeline('None', '_');
        this.setAvailabilityMessage('Awesome, this size is available to ship!');
        this.setInStockCheckbox(true);
      } else if (variant.inventoryPolicy === 'CONTINUE' || variant.isTracked === false) {
        this.$inventoryStatusInput.value = 'In Production';
        this.setTimeline(this.$manufacturingTimelineInput?.dataset?.defaultValue, '');
        if (this.$availabilityMessage?.hasAttribute('custom-timeline')) {
          this.setAvailabilityMessage(
            `We will start hand building that size on an ${this.$availabilityMessage?.dataset.stockTimeline} week timeline!`,
          );
        } else {
          this.setAvailabilityMessage(
            `Made to order for you on an ${this.$availabilityMessage?.dataset.stockTimeline} week timeline.`,
          );
        }
        this.$inStockCheckbox?.checked && this.setInStockCheckbox(false);
      } else {
        this.$inventoryStatusInput.value = 'Out Of Stock';
        this.setTimeline('None', '_');
        if (this.$availabilityMessage?.hasAttribute('custom-timeline')) {
          this.$availabilityMessage.parentElement?.classList.add('hide');
        } else {
          if (this.dropNotifications) {
            this.setAvailabilityMessage('Subscribe to our email list to know when we drop it next');
          } else {
            this.setAvailabilityMessage('Sorry, this product is currently unavailable.');
          }
        }
        this.$inStockCheckbox?.checked && this.setInStockCheckbox(false);
      }
    }

    setAvailabilityMessage(message) {
      if (!this.$availabilityMessage) return;
      this.$availabilityMessage.parentElement?.classList.remove('hide');
      this.$availabilityMessage.innerHTML = message;
    }

    setInStockCheckbox(value) {
      if (!this.$inStockCheckbox) return;
      this.$inStockCheckbox.checked = value;
      this.$inStockCheckbox.dispatchEvent(new Event('change'));
    }

    setTimeline(value, leading) {
      if (this.$manufacturingTimelineInput) {
        this.$manufacturingTimelineInput.value = value;
        this.$manufacturingTimelineInput.name = `properties[${leading}Manufacturing Timeline]`;
      }
    }

    unsubscribe() {
      this.onOptionValueChangeUnsubscriber?.();
    }
  };
})();
